import React, { useState, useEffect, Fragment } from "react";
import { Typography, Switch, Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  switchLabel: {
    marginTop: 20,
    textAlign: "center",
  },
  boxSwitch: {
    display: "flex",
    justifyContent: "space-around",
  },
  labelRangeLeft: {
    width: "100%",
    textAlign: "left",
    marginLeft: 20,
  },
  labelRangeRight: {
    width: "100%",
    textAlign: "right",
    marginRight: 20,
  },
}));

const Step1 = (props) => {
  const classes = useStyles();
  const [value, setValue] = useState({
    qualite: 50,
    presence: false,
    interruption: false,
    passage_dangereux: false,
    parking_velos: false,
  });

  useEffect(() => {
    // Quand le composant se charge, autorise à passer à la suite
    props.setAuthorization(true);
    // Insérer les réponses par défaut des switch dans la réponse
    for (let element in value) {
      props.result[element] = value[element];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event) => {
    // Set la value du state du composant local
    setValue({ ...value, [event.target.name]: event.target.checked });
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult[event.target.name] = event.target.checked;
    props.setResult(newResult);
  };

  const handleRangeChange = (event) => {
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult[event.target.name] = event.target.valueAsNumber;
    props.setResult(newResult);
    // Une fois que la réponse est donnée, autorise à avancer dans le form
    props.setAuthorization(true);
  };

  return (
    <Fragment>
      <Typography variant="body1" component="legend" style={{ marginLeft: 20 }}>
        Je renseigne des informations sur l'offre proposée :
      </Typography>
      {/* Première ligne */}
      <Typography variant="body1" className={classes.switchLabel}>
        La qualité de la prestation
      </Typography>
      <Box className={classes.boxSwitch}>
        <Typography variant="body1" className={classes.labelRangeLeft}>
          Médiocre
        </Typography>
        <input
          name="qualite"
          type="range"
          min="0"
          max="100"
          onChange={handleRangeChange}
        />
        <Typography variant="body1" className={classes.labelRangeRight}>
          Excellente
        </Typography>
      </Box>
      {/* Deuxième ligne */}
      <Typography variant="body1" className={classes.switchLabel}>
        Une piste cyclable . . .
      </Typography>
      <Box className={classes.boxSwitch}>
        <Typography variant="body1" className={classes.labelRangeLeft}>
          Il en faudrait
        </Typography>
        <Switch
          name="presence"
          checked={value.presence}
          onChange={handleChange}
        />
        <Typography variant="body1" className={classes.labelRangeRight}>
          Il y en a
        </Typography>
      </Box>
      {/* Troisième ligne */}
      <Typography variant="body1" className={classes.switchLabel}>
        La piste cyclabe est interrompue
      </Typography>
      <Box className={classes.boxSwitch}>
        <Typography variant="body1" className={classes.labelRangeLeft}>
          Non
        </Typography>
        <Switch
          name="interruption"
          checked={value.interruption}
          onChange={handleChange}
        />
        <Typography variant="body1" className={classes.labelRangeRight}>
          Oui
        </Typography>
      </Box>
      {/* Quatrième ligne */}
      <Typography variant="body1" className={classes.switchLabel}>
        Le passage est dangereux
      </Typography>
      <Box className={classes.boxSwitch}>
        <Typography variant="body1" className={classes.labelRangeLeft}>
          Non
        </Typography>
        <Switch
          name="passage_dangereux"
          checked={value.passage_dangereux}
          onChange={handleChange}
        />
        <Typography variant="body1" className={classes.labelRangeRight}>
          Oui
        </Typography>
      </Box>
      {/* Cinquième ligne */}
      <Typography variant="body1" className={classes.switchLabel}>
        Il y a un parking à velos
      </Typography>
      <Box className={classes.boxSwitch}>
        <Typography variant="body1" className={classes.labelRangeLeft}>
          Non
        </Typography>
        <Switch
          name="parking_velos"
          checked={value.parking_velos}
          onChange={handleChange}
        />
        <Typography variant="body1" className={classes.labelRangeRight}>
          Oui
        </Typography>
      </Box>
    </Fragment>
  );
};

export default Step1;
